module.exports = __webpack_public_path__ + "static/media/manifest.b0f0a230.svg";